import { Outlet, Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { EarthLoader } from "./Hooks/PageLoader";
import { useApp } from "./APIHelpers/AppContext";
import TwoFactorAuth from "./Pages/RestrictedPages/TwoFactorAuth";
import SelectAccount from "./Pages/RestrictedPages/SelectAccount";
import NotFoundPage from "./Pages/RestrictedPages/NotFoundPage";

const AllPermission = () => {
  const auth = localStorage.getItem("token");
  const { slug } = useParams();
  const {
    getCurrectLoginUser,
    currentUserData,
    isUserLoading,
    isDark
  } = useApp();

  useEffect(() => {
    if (auth && !currentUserData) {
      getCurrectLoginUser();
    }
  }, [auth, currentUserData, getCurrectLoginUser]);

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (isUserLoading || !currentUserData) {
    return (
      <div style={{ height: "100vh" }}>
        <EarthLoader />
      </div>
    );
  }

  if (currentUserData?.loginSlugName !== slug) {
    return <NotFoundPage />;
  }

  if (currentUserData?.twoFA) {
    return (
      <TwoFactorAuth
        currentUserData={currentUserData}
        isDark={isDark}
      />
    );
  }

  if (
    currentUserData?.roleType === "organization" &&
    !currentUserData?.loginAccountId
  ) {
    return (
      <SelectAccount
        currentUserData={currentUserData}
        getCurrectLoginUser={getCurrectLoginUser}
      />
    );
  }

  return <Outlet />;
};

const LoginPermission = () => {
  const auth = localStorage.getItem("token");
  const { currentUserData, isUserLoading } = useApp();
  if (!auth) {
    return <Outlet />;
  }
  if (isUserLoading) {
    return null;
  }
  if (currentUserData?.loginSlugName) {
    return <Navigate to={`/${currentUserData.loginSlugName}`} replace />;
  }
  return null;
};

export const Permission = {
  LoginPermission,
  AllPermission,
};